import { render } from "./NFTStaked.vue?vue&type=template&id=3071977c&ts=true"
import script from "./NFTStaked.vue?vue&type=script&lang=ts"
export * from "./NFTStaked.vue?vue&type=script&lang=ts"

import "./NFTStaked.vue?vue&type=style&index=0&id=3071977c&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__